<template>
    <el-dialog 
        title="新增商机" 
        :visible.sync="addShow" 
        :close-on-click-modal="false"
        width="750px" 
        ref="dialog" 
        @close="editorClose"
    >
        <AddDealer ref="addDealer" @confirmSeasFun="onModalSubmit"/>
    </el-dialog>
</template>

<script>
import AddDealer from './addDealer'
export default {
  components: {
    AddDealer
  },
  data() {
    return {
      addShow: false,
    }
  },
  methods: {
    open() {
      this.addShow = true
      this.$nextTick(()=> {
        this.$refs.addDealer.get()
      })
    },
    editorClose() {
      this.addShow = false
    },
    onModalSubmit(val){
      this.$emit('onSubmit', val)
    },
  }
}
</script>
